import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { apiAction, generalSet } from '../../store/generalSlice';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../layout/Spinner';
import ShowPageAdsVolume from './ShowPageAdsVolume';
import ShowPageAdsVolumeFromDB from './ShowPageAdsVolumeFromDB';

const AlternativePagesCron = () => {
  const dispatch = useDispatch();
  const { accountsForPageLimitCron, loadingRetryRules, updatedAltPages, loadingUpdatedAltPages } = useSelector(
    (state) => state.general
  );

  const [showAdVolumeAppLevel, setShowAdVolumeAppLevel] = useState([]);
  const [showAdVolumeUserLevel, setShowAdVolumeUserLevel] = useState([]);
  const [showAdVolumeFromDB, setShowAdVolumeFromDB] = useState([]);

  const getAccountsForPageLimitCron = () => {
    dispatch(generalSet({ reduxField: 'loadingRetryRules', value: true }));
    dispatch(
      apiAction({
        reduxField: 'accountsForPageLimitCron',
        route: 'alternativePages/getAccountsForPageLimitCron',
        setLoading: 'loadingRetryRules',
      })
    );
  };

  const updateAlternativePageAdsValume = () => {
    dispatch(generalSet({ reduxField: 'loadingUpdatedAltPages', value: true }));
    dispatch(
      apiAction({
        reduxField: 'updatedAltPages',
        route: 'alternativePages/updateAlternativePageAdsValume',
        setLoading: 'loadingUpdatedAltPages',
      })
    );
  };

  useEffect(() => {
    getAccountsForPageLimitCron();
  }, []);

  const columns = [
    {
      field: 'traffic_channel_id',
      headerName: 'traffic_channel_id',
      width: 250,
    },
    {
      field: 'alt_instagram_user_id',
      headerName: 'alt_instagram_user_id',
      width: 250,
    },
    {
      field: 'alt_page_id',
      headerName: 'alt_page_id',
      width: 200,
    },
    {
      field: 'num_of_ads',
      headerName: 'num_of_ads',
      width: 200,
    },
    {
      field: 'show_ads_volume',
      headerName: 'Show Ads Volume App Token',
      width: 200,
      renderCell: (params) => (
        <>
          {showAdVolumeAppLevel.includes(params.row.id) ? (
            <ShowPageAdsVolume
              key={params.row.id}
              accountId={params.row.traffic_channel_id}
              pageId={params.row.alt_page_id}
            />
          ) : (
            <button
              className='btn btn-outline-dark'
              onClick={() => setShowAdVolumeAppLevel((state) => [...state, params.row.id])}
            >
              Show Ad Volume
            </button>
          )}
        </>
      ),
    },
    {
      field: 'show_ads_volume_user_token',
      headerName: 'Show Ads Volume User Token',
      width: 200,
      renderCell: (params) => (
        <>
          {showAdVolumeUserLevel.includes(params.row.id) ? (
            <ShowPageAdsVolume
              key={params.row.id}
              accountId={params.row.traffic_channel_id}
              pageId={params.row.alt_page_id}
              userToken={true}
            />
          ) : (
            <button
              className='btn btn-outline-dark'
              onClick={() => setShowAdVolumeUserLevel((state) => [...state, params.row.id])}
            >
              Show Ad Volume
            </button>
          )}
        </>
      ),
    },
    {
      field: 'show_ads_volume_from_db',
      headerName: 'Show Ads Volume From DB',
      width: 200,
      renderCell: (params) => (
        <>
          {showAdVolumeFromDB.includes(params.row.id) ? (
            <ShowPageAdsVolumeFromDB key={params.row.id} pageId={params.row.alt_page_id} />
          ) : (
            <button
              className='btn btn-outline-dark'
              onClick={() => setShowAdVolumeFromDB((state) => [...state, params.row.id])}
            >
              Show Ad Volume
            </button>
          )}
        </>
      ),
    },
  ];
  console.log({ accountsForPageLimitCron, updatedAltPages });
  return loadingRetryRules ? (
    <Spinner />
  ) : (
    <div className='p-2' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom mt-4'>
        <h5>Alternative Pages Cron Tester</h5>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
        {loadingUpdatedAltPages ? (
          <Spinner />
        ) : (
          <button
            className='btn btn-outline-primary'
            onClick={() => {
              updateAlternativePageAdsValume();
            }}
          >
            Align Alternative Pages Ads Volume
          </button>
        )}
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 mt-4 p-3'>
        <Box style={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={accountsForPageLimitCron?.accountsFromAlternativePagesResult || []}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            //   checkboxSelection
            disableSelectionOnClick
          />
        </Box>
      </div>
    </div>
  );
};

export default AlternativePagesCron;
